export default __webpack_public_path__ + "static/media/iconoCrear.bd1c8e68.svg";